import { Actions } from "../table/table.actions"
import createTableReducer, { DEFAULT_STATE } from "../table/table.reducer"

const INITIAL_STATE = {
  ...DEFAULT_STATE,
  sorting: ["name=asc"],
  defaultSorting: ["name=asc", "templates.updated_at=asc", "conflicts_count=asc"],
}

const templateTableReducer = (state = INITIAL_STATE, action: Actions) =>
  createTableReducer("TEMPLATE_TABLE", {})(state, action)

export default templateTableReducer
